import _ from 'lodash';

/**
 * @name Payments
 * @description The payments service
 * @param {angular} $http The Angular $http service
 * @param {angular} $q The Angular $q service
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {constant} PAYMENT_STATUS_IDS The PAYMENT_STATUS_IDS constant
 * @param {service} AlertMessages The AlertMessages service
 * @param {service} Session The Session service
 * @return {type} Returns the factory
 */
function Payments(
  $http,
  $q,
  ENDPOINT,
  PAYMENT_STATUS_IDS,
  AlertMessages,
  Session
) {
  // Public Functions
  Payments.process = process;
  Payments.create = create;
  Payments.getTypes = getTypes;
  Payments.update = update;

  /**
  * @name submit
  * @description Function to save a payments
  * @param {unknown} payment Unknown.
  * @return {unknown} Returns the saved payment.
  */
  function create(payment) {
    // Set the association and role
    if (!_.isUndefined(Session.activeState.association)) {
      payment.association_id = Session.activeState.association.id;
    }
    payment.role = Session.activeState.role;
    return $http.post(ENDPOINT.server + 'payments/api/v1.1/create/', payment)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getPaymentTypes
   * @description Get Payment Types
   * @return {unknown} data Returns the payment types
   */
  function getTypes() {
    return $http.get(ENDPOINT.server + 'payments/api/v1.1/all/payment-types/')
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name updatePaymentStatus
   * @description Update payment status
   * @param {unknown} payment Unknown
   * @param {unknown} status Unknown
   * @return {unknown} data Returns the updated payment
   */
  function update(payment) {
    // Set the association and role
    if (!_.isUndefined(Session.activeState.association)) {
      payment.association_id = Session.activeState.association.id;
    }
    payment.role = Session.activeState.role;
    let url = ENDPOINT.server + 'payments/api/v1.1/' + payment.id + '/';
    return $http.put(url, payment)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name process
   * @description Process appointent payments
   * @param {object} appointment The appoinment payments to process
   * @return {object} paymentData Returns the processed payments
   */
  function process(appointment) {
    return $q(function(resolve, reject) {
      const paymentData = {};

      // Format the price
      if (appointment.price) {
        paymentData.price = parseFloat(appointment.price);
      }

      // Calculate totals
      paymentData.hasPaidDeposit = false;
      if (appointment.payments && appointment.payments.length > 0) {
        // Total payments
        paymentData.total =
        appointment.payments.reduce((all, payment) => {
          if (payment.status === PAYMENT_STATUS_IDS.approved
          && !payment.is_tip) {
            return all + payment.amount;
          }
          return all;
        }, 0);

        // Create deposit payments array
        let depositPayments = appointment.payments.filter((payment) =>
        payment.is_deposit === true);

        // Total deposit payments
        paymentData.depositTotal = depositPayments.reduce((all, payment) => {
          if (payment.status === PAYMENT_STATUS_IDS.approved) {
            return all + payment.amount;
          }
          return all;
        }, 0);

        // Create tip payments array
        let tipPayments = appointment.payments.filter((payment) =>
        payment.is_tip === true);

        // Total tip payments
        paymentData.tipTotal = 0;
        if (tipPayments.length) {
          paymentData.tipTotal = tipPayments.reduce((all, payment) => {
            if (payment.status === PAYMENT_STATUS_IDS.approved) {
              return all + payment.amount;
            }
            return all;
          }, 0);
        }

        // Set a deposit paid boolean if the deposit total is => deposit_amount
        if (appointment.deposit_amount &&
        paymentData.depositTotal >= appointment.deposit_amount) {
          paymentData.hasPaidDeposit = true;
        }
      }

      // Caculate the balance
      if (paymentData.price && paymentData.total) {
        paymentData.balance =
        paymentData.price - paymentData.total;
      }
      resolve(paymentData);
    });
  }
  return Payments;
}

angular
  .module('inkfinder')
  .factory('Payments', Payments);



// WEBPACK FOOTER //
// ./components/appointments/appointment/payments/payments.service.js